// Don't export this from index because components that are rendered by react-router may
// also import below. This would result in "cannot access unintialized variable" error

import { CRMBedboardRoutes } from './getCrmRoutes/getCrmBedboardRoutes';
import { CRMScreenerResidentsRoutes } from './getCrmRoutes/getCrmScreenerResidentsRoutes';
import { CRMScreenerRoutes } from './getCrmRoutes/getCrmScreenerRoutes';
import { CRMSourcesRoutes } from './getCrmRoutes/getCrmSourcesRoutes';
import { CRMTaskRoutes } from './getCrmRoutes/getCrmTasksRoutes';
import { CRMWaitlistRoutes } from './getCrmRoutes/getCrmWaitlistRoutes';
import { AddStaffRoutes } from './getSharedRoutes/getAddStaffRoutes';
import { AdminHubGeneralRoutes } from './getSharedRoutes/getAdminHubGeneralRoutes';
import { AdminHubStaffOverviewRoutes } from './getSharedRoutes/getAdminHubStaffOverviewRoutes';
import { DataCenterRoutes } from './getSharedRoutes/getDataCenterRoutes';
import { AdminHubOrgWideSettingsRoutes } from './getSharedRoutes/getOrgWideSettingsRoutes';
import { StaffRoutes } from './getSharedRoutes/getStaffRoutes';

enum ErrorRoutes {
  Error = '/error',
  Unauthorized = '/unauthorized'
}

export enum TaskRoutes {
  TasksChronological = '/tasks/chronological',
  TasksByResident = '/tasks/by-resident'
}

enum ProfileRoutes {
  EHRProfile = '/profile',
  EHRProfileShifts = '/profile/shifts',
  Profile = '/crm/profile',
  ProfileShifts = '/crm/profile/shifts'
}

enum SecretRoutes {
  SecretFeatureFlagService = '/secret-feature-flag-service'
}

export const RoutePath = {
  ...ErrorRoutes,
  ...CRMScreenerResidentsRoutes,
  ...StaffRoutes,
  ...AddStaffRoutes,
  ...TaskRoutes,
  ...ProfileRoutes,
  ...AdminHubGeneralRoutes,
  ...AdminHubStaffOverviewRoutes,
  ...DataCenterRoutes,
  ...CRMTaskRoutes,
  ...CRMSourcesRoutes,
  ...CRMScreenerRoutes,
  ...CRMWaitlistRoutes,
  ...CRMBedboardRoutes,
  ...SecretRoutes,
  ...AdminHubOrgWideSettingsRoutes
} as const;

export type RoutePath = (typeof RoutePath)[keyof typeof RoutePath];
